class NumberHelper {
  static formatPrice(num) {
    const formatter = Intl.NumberFormat('en-US', {
      currency: 'USD',
      minimumFractionDigits: 0,
    });
    return formatter.format(num);
  }

  static round(num, decimalPlaces) {
    return Math.round(num * (10 ** decimalPlaces)) / (10 ** decimalPlaces);
  }

  static roundInteger(num, digitThreshold, up) {
    if (num === 0) {
      return 0;
    }
    let digitAmount = Math.ceil(Math.log(num) * Math.LOG10E);
    let adjustedDigitThreshold = digitThreshold;
    if (!up) {
      digitAmount -= 1;
      adjustedDigitThreshold -= 1;
    }
    const threshold = digitAmount < adjustedDigitThreshold
      ? 10 ** digitAmount
      : 10 ** adjustedDigitThreshold;
    if (up) {
      return Math.ceil(num / threshold) * threshold;
    }
    return Math.floor(num / threshold) * threshold;
  }
  /*
    Rounds an integer to the nearest bigger 'round' integer.
    `Rounding` in this context means finding a number with as much
    zeros as possible. For example:
    1298741 => 130000
    865 => 900

    The function expects a `digitThreshold` argument that specifies
    the maximum amount of least significant digits to zero.
  */
  static roundIntegerUp(num, digitThreshold) {
    return NumberHelper.roundInteger(num, digitThreshold, true);
  }

  /*
    Rounds an integer to the nearest smaller 'round' integer.
    `Rounding` in this context means finding a number with as much
    zeros as possible. For example:
    1298741 => 129000
    865 => 800

    The function expects a `digitThreshold` argument that specifies
    the maximum amount of least significant digits to zero.
  */
  static roundIntegerDown(num, digitThreshold) {
    return NumberHelper.roundInteger(num, digitThreshold, false);
  }

  /*
    This function returns an array of numbers in ascending order
    that specify multiple intervals. The first and last number are
    `min` and `max` respectively.

    To find the intervals, the min-max interval is transformed to
    the logarithmic space, split in `parts` evenly-spaced parts, and then transformed back
    to the linear space. Mathematically speaking, this equation describes the N-th threshold.

    thresholdN = exp((ln(max) - ln(min)) * N / parts + ln(min))

    Where `exp` is the exponential function.
  */
  static logarithmicIntervalsFor(max, min, parts) {
    const thresholds = [];
    if (parts === 0) {
      return thresholds;
    }
    const lnMax = Math.log(max);
    const lnMin = Math.log(min);

    for (let i = 0; i < parts + 1; i += 1) {
      if (i === 0) {
        thresholds.push(min);
      } else if (i === parts) {
        thresholds.push(max);
      } else {
        thresholds.push(Math.round(Math.exp((((lnMax - lnMin) * i) / parts) + lnMin)));
      }
    }
    return thresholds;
  }

  static localizeNumber(num) {
    return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
  }
}

export { NumberHelper };



// WEBPACK FOOTER //
// ./src/helpers/NumberHelper.js